import { render, staticRenderFns } from "./tat.vue?vue&type=template&id=55b77932&scoped=true"
import script from "./tat.vue?vue&type=script&lang=js"
export * from "./tat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b77932",
  null
  
)

export default component.exports